import { NEXT_IMAGE_QUALITY } from 'src/common/constants/imageQuality'

export const contentfulImageLoader =
  (supportsWebp = true, proxy = false) =>
  ({ src, width, quality = NEXT_IMAGE_QUALITY }) =>
    `${src}?w=${width}&q=${quality}${supportsWebp ? '&fm=webp' : ''}`
